<template>
	<div class="rdsc_wrap">
		<audio ref="music1" id="audio" autoplay="autoplay" crossOrigin="true" :src="src">
			当前浏览器不支持audio
		</audio>
		<div class="control_group">
			<div class="control_group_item" @click="change(1)" :class="{control_group_select:select == 1}">入党誓词</div>
			<div class="control_group_item" @click="change(2)" :class="{control_group_select:select == 2}">习近平领誓</div>
			<div class="control_group_item" @click="change(3)" :class="{control_group_select:select == 3}">奏唱国歌</div>
		</div>
		<div class="rdsc_center">
			<div class="centers">
				<div class="center_title">入党誓词</div>
				<div class="center_words" ref="center_words" v-if="select == 1">
					{{words}}
				</div>
				<div class="center_words" ref="center_words" v-if="select == 2">
					<span :key="index" v-for="(item,index) in center_words">{{item}}</span>
				</div>
			</div>
			<div class="rdsc_word anim1" v-if="select!=3">
				<img src="@/assets/rdsc_word.png" alt="">
			</div>
			<div class="bird" v-if="select!=3">
				<img src="@/assets/bird.png" alt="">
			</div>
			<div class="icon_left" v-if="select == 1">
				<img src="@/assets/rdsc_icon_left.png" alt="">
			</div>
			<div class="icon_right" v-if="select!=3">
				<img src="@/assets/rdsc_icon_right.png" alt="">
			</div>
			<div class="xdd" v-if="select == 2">
				<img src="@/assets/xdd.png" alt="">
			</div>
			<video class="videos" autoplay loop v-if="select == 3">
				<source src="https://people.5cy.com/p1/dj/video/ggym.mp4" type="video/mp4">
				</source>
			</video>
		</div>
	</div>
</template>
<script>
	export default {

		data() {
			return {
				select: 1,
				src: "",
				audio: null,
				words: "我志愿加入中国共产党，拥护党的纲领，遵守党的章程，履行党员义务，执行党的决定，严守党的纪律，保守党的秘密，对党忠诚，积极工作，为共产主义奋斗终身，随时准备为党和人民牺牲一切，永不叛党。",
				center_words: [],
				timer: null
			}
		},
		mounted() {
			let that = this;
			that.audio = new Audio();
		},
		beforeDestroy() {
			let that = this;
			that.audio.src = "";
			clearTimeout(that.timer)
		},
		methods: {
			change(index) {
				let that = this;
				that.select = index;
				that.audio.src = "";
				clearTimeout(that.timer)
				if (index == 2) {
					that.center_words = that.words.trim()
					that.timer = setTimeout(() => {
						that.audio.src = require("@/assets/lingshi.mp3");
						that.audio.play()
					}, 2500)
				}
			},
			// 返回
			goIndex() {
				history.back();
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './rdsc.scss';
</style>
